import * as action_types from '../actions/actionTypes'

const initialState = {
  data: null,
  isLoading: false
}

export default function userUpdate(state = initialState, {type, payload}) {
  switch (type) {
  case action_types.USER_LOGGING_IN:
    return {...initialState, isLoading: true}
  case action_types.USER_LOGGED_IN:
    return {data: payload, isLoading: false}
  case action_types.USER_REFRESH_TOKEN:
    return {data: {...state.data, ...payload}, isLoading: false}
  case action_types.USER_LOGGED_OUT:
    return initialState
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js